import React from "react";
import PropTypes from "prop-types";

import TypesUtils from "../../inumet_js_lib/utils/typesUtils";
import { StyleForms } from "../../res/styles/styleForms";
import StylesUtils from "../../res/styles/stylesUtils";
import Colors from "../../res/colors/colors";
import StringUtils from "../../inumet_js_lib/utils/stringUtils";
import FAIcon from "../icons/faIcon"

import ErrorOverlay from "../controls/errorOverlay";
import { Form, Col } from "react-bootstrap";

const DEFAULT_ERROR_TOOLTIP_PLACEMENT= "right";

class FormElement extends React.Component {
  constructor(props){
    super(props);
    this.selectRef= React.createRef();
    this.state={controlId:props.id};
    if (!props.label)
      this.state.controlId = props.label + Math.random().toString()
  }

  render() {
    let hasLabel= StringUtils.notNullNotEmpty(this.props.label);
    let labelComponent = hasLabel ? (
      <label disabled={this.props.isDisabled}>
        <span
          style={
            this.props.labelStyle
              ? this.props.labelStyle
              : StyleForms.smallLabel
          }
        >
          {this.props.label}
        </span>
      </label>
    ) : null;
    let classNameDiv = StylesUtils.getMarginClasses(
      this.props.mt,
      this.props.mr,
      this.props.mb,
      this.props.ml
    );
    let errorTooltip = (
      <ErrorOverlay
        componentRef={this.selectRef}
        errorText={this.props.errorText}
        placement={StringUtils.notNullNotEmpty(this.props.errorTooltipPlacement)? this.props.errorTooltipPlacement : DEFAULT_ERROR_TOOLTIP_PLACEMENT}
      />
    );


    let helpComponent = null;
    let hasHelp = TypesUtils.notUndefOrNull(this.props.helpText);
    if (hasHelp) {
      helpComponent = (
        <FAIcon
          color={Colors.fieldHelpIcon}
          verticalCenter
          iconId={"info-circle"}
          size={1}
          fas
          ml={2}
          textOnHover={this.props.helpText}
        />
      );
    }


    return (
      <Form.Group
        as={Col}
        controlId={this.state.controlId}
        className={classNameDiv}
      >
       {hasLabel && <Form.Label ref={this.selectRef}>
          {labelComponent}
          {hasHelp && helpComponent}
        </Form.Label>}
        {this.props.children}
        {errorTooltip}
      </Form.Group>
    );
  }
}

FormElement.propTypes = {
  labelStyle: PropTypes.object,
  label: PropTypes.string,
  loading: PropTypes.bool,
  helpText:PropTypes.string,
  mt: PropTypes.number,
  mr: PropTypes.number,
  ml: PropTypes.number,
  mb: PropTypes.number,
  isDisabled: PropTypes.bool,
  errorText: PropTypes.string,
  children:PropTypes.element,
  errorTooltipPlacement:PropTypes.string,
  id:PropTypes.string,
};

export { FormElement as default };
